"use strict";

exports.__esModule = true;
exports["default"] = exports.SortControls = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _radioSort = _interopRequireDefault(require("./radio-sort"));

var _tabBar = _interopRequireDefault(require("../tab-bar"));

var _excluded = ["buttonFont", "disabled", "groupLabel", "groupName", "labelFont", "selectedOption", "sortOnChange", "sortOptions", "tabFont", "withTabBar"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultLabelFont = {
  color: "text-light-grey",
  fontSize: [1, 1, 0],
  fontWeight: 500,
  letterSpacing: ["1.8px", "1.8px", "1.5px"],
  lineHeight: [1, 1, 2],
  mb: 2
};
var defaultButtonFont = {
  color: "body-grey",
  direction: ["row-reverse", "initial"],
  fontSize: 1,
  fontWeight: 1,
  justifyContent: ["space-between", "initial"],
  letterSpacing: "0.43px",
  lineHeight: 3,
  mb: ["0px", "14px"],
  py: ["14px", "0px"]
};
var defaultTabFont = {
  color: null,
  fontSize: 2,
  fontWeight: 2,
  letterSpacing: "0.5px",
  lineHeight: 2,
  mb: null
};
var propTypes = {
  // Font parameters for each Radio Button
  buttonFont: (0, _propTypes.shape)({
    fontSize: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number, _propTypes.array])
  }),
  disabled: _propTypes.bool,

  /** Label for the group */
  groupLabel: _propTypes.node,
  // Name of radio button group
  groupName: _propTypes.string,
  // Font parameters for group label
  labelFont: (0, _propTypes.shape)({
    fontSize: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number, _propTypes.array])
  }),
  // The currently selected sort option
  selectedOption: _propTypes.string,

  /** sortOnChange event handler - used to process the event */
  sortOnChange: _propTypes.func,

  /** List of sort options, either array or object  */
  sortOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    disabled: _propTypes.bool,
    id: _propTypes.string,
    label: _propTypes.string,
    value: _propTypes.string
  })),
  // Font parameters for tabs
  tabFont: (0, _propTypes.shape)({
    fontSize: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number, _propTypes.array])
  }),

  /** Determines if tab bar should show on mobile instead of radio buttons */
  withTabBar: _propTypes.bool
};
var defaultProps = {
  buttonFont: defaultButtonFont,
  groupLabel: "SORT BY",
  groupName: "sort-controls",
  labelFont: defaultLabelFont,
  tabFont: defaultTabFont,
  withTabBar: false
};

var SortControls = function SortControls(_ref) {
  var buttonFont = _ref.buttonFont,
      disabled = _ref.disabled,
      groupLabel = _ref.groupLabel,
      groupName = _ref.groupName,
      labelFont = _ref.labelFont,
      selectedOption = _ref.selectedOption,
      sortOnChange = _ref.sortOnChange,
      sortOptions = _ref.sortOptions,
      tabFont = _ref.tabFont,
      withTabBar = _ref.withTabBar,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var radioDisplayProps = (0, _react.useMemo)(function () {
    return withTabBar ? ["none", "none", "block"] : "block";
  }, [withTabBar]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    display: radioDisplayProps,
    my: 2,
    width: 1
  }, props), /*#__PURE__*/_react["default"].createElement(_radioSort["default"], {
    buttonFont: buttonFont,
    disabled: disabled,
    groupLabel: groupLabel,
    groupName: groupName,
    labelFont: labelFont,
    radioButtonOnChange: sortOnChange,
    selectedOption: selectedOption,
    sortOptions: sortOptions
  })), withTabBar && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    display: ["block", "block", "none"],
    my: 2,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_tabBar["default"], {
    buttonFont: tabFont,
    disabled: disabled,
    groupLabel: groupLabel,
    groupName: "mobile-tabs-" + groupName,
    labelFont: labelFont,
    options: sortOptions,
    selectedOption: selectedOption,
    tabBarOnChange: sortOnChange
  })));
};

exports.SortControls = SortControls;
SortControls.propTypes = propTypes;
SortControls.defaultProps = defaultProps;
SortControls.displayName = "Modules.SortControls)";
var _default = SortControls;
exports["default"] = _default;